<mat-card class="card-mobile" appearance="outlined">
    <mat-card-header>
      <div class="card-symptom-header-mobile">
        <div class="card-symptom-icon" style="margin-right: 40px;">
          <app-cold-sinus-flu-icon-svg *ngIf="photoUrl == 'Cold-Sinus-Flu-Icon.svg'" style="fill: #8266BC;"></app-cold-sinus-flu-icon-svg>
          <app-pink-eye-icon-svg *ngIf="photoUrl == 'Pink-Eye-Icon.svg'" style="fill: #8266BC;"></app-pink-eye-icon-svg>
          <app-yeast-infection-icon-svg *ngIf="photoUrl == 'Yeast-Infection-Icon.svg'" style="fill: #8266BC;"></app-yeast-infection-icon-svg>
          <app-urinary-tract-infection-icon-svg *ngIf="photoUrl == 'Urinary-Tract-Infection-Icon.svg'" style="fill: #8266BC;"></app-urinary-tract-infection-icon-svg>
          <app-stomach-issues-icon-svg *ngIf="photoUrl == 'Stomach-Issues-Icon.svg'" style="fill: #8266BC;"></app-stomach-issues-icon-svg>
          <app-skin-condition-icon-svg *ngIf="photoUrl == 'Skin-Condition-Icon.svg'" style="fill: #8266BC;"></app-skin-condition-icon-svg>
          <app-ear-pain-icon-svg *ngIf="photoUrl == 'Ear-Pain-Icon.svg'" style="fill: #8266BC;"></app-ear-pain-icon-svg>
        </div>
        <div class="card-provider-wait-time-container-mobile" style="align-items: end; margin-left: 16px;" *ngIf="waitTime != null && waitTime !=''">
          <div class="card-provider-book-as-soon-as-mobile">
              {{this.soonAsText}}
          </div>
          <div class="card-provider-availability-mobile">
              {{waitTime}} {{minutesText}}
          </div>
        </div>
      </div>
    </mat-card-header>
    <mat-card-content class="card-provider-content-mobile">
      <mat-card-title class="card-symptom-title-mobile">{{title}}</mat-card-title>
    </mat-card-content>
    <mat-card-actions class="card-provider-actions-mobile">
        <div class="card-provider-detail-bottom-left"></div>
        <button mat-button class="action-button-primary" style="width: 91px" (click)="startNow()">{{startNowText}}</button>
    </mat-card-actions>
</mat-card>
